module.exports = __webpack_public_path__ + "static/img/skyline-right-min.0c3b7f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/skyline-right-min.png
// module id = 683
// module chunks = 64